<template>
  <b-sidebar
    id="sidebar-backdrop"
    ref="sidebar"
    width="280px"
    no-header
    backdrop
    shadow
    bg-variant="white"
    right
    @change="onChange"
  >
    <div class="px-3 py-2">
      <div class="card">
        <div class="body">
          <div class="align-center mt-3 text-center">
            <div class="profile-image">
              <el-upload
                class="avatar-uploader"
                action="/oss/ossUploadReturnUrlAndFileId"
                :show-file-list="false"
                :data="fileData"
                :on-success="handleAvatarSuccess"
              >
                <img
                  :src="info.avatar || defaultAvatar"
                  width="120px"
                  height="120px"
                  class="rounded-circle"
                  alt
                />
              </el-upload>
            </div>
            <div class="mt-3">
              <h5 class="m-b-2">{{ info.userName }}</h5>
            </div>
          </div>
          <div class="border-top p-t-10 m-t-10 text-left">
            <ul class="list-unstyled">
              <li class="mt-2">
                <i
                  class="fa fa-graduation-cap text-muted font-16 ml-1 mr-2 list-icon"
                ></i>
                {{ info.userPost }}
              </li>
              <li class="mt-2">
                <i
                  class="fa fa-users text-muted font-16 ml-1 mr-2 list-icon"
                ></i>
                {{ info.dept }}
              </li>
              <li class="mt-2">
                <i
                  class="fa fa-heartbeat text-muted font-16 ml-1 mr-2 list-icon"
                ></i>
                {{ info.mobileNumber }}
              </li>
              <li class="mt-2">
                <i
                  class="fa fa-envelope-o text-muted font-16 ml-1 mr-2 list-icon"
                ></i>
                {{ info.email }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="header">
          <h3>{{ $l('INDEX.security_title') }}</h3>
        </div>
        <div class="body">
          <RestPasswordForm
            ref="resetPasswordForm"
            size="small"
            :userCode="info.userCode"
          />
          <el-button
            type="primary"
            class="btn-block mt-4"
            :loading="changePasswordLoading"
            @click="changePassword"
            >{{ $l('INDEX.security_btn') }}</el-button
          >
        </div>
      </div>
      <div class="card">
        <div class="body">
          <el-button type="danger" class="btn-block" @click="logout">{{
            $l('INDEX.logout')
          }}</el-button>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RestPasswordForm from '@/components/resetpassword/form'
export default {
  components: { RestPasswordForm },
  data() {
    return {
      fileData: {
        expirationsec: 0,
        fileproperty: 'publicfiles'
      },
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      changePasswordLoading: false
    }
  },
  computed: {
    ...mapState('admin/user', ['info'])
  },
  methods: {
    ...mapActions('admin/user', ['set']),
    ...mapActions('admin/account', ['logout']),
    changePassword() {
      this.changePasswordLoading = true
      this.$refs.resetPasswordForm
        .submit()
        .then(() => {
          this.changePasswordLoading = false
          this.$message({
            message: '密码修改成功',
            type: 'success'
          })
          this.logout()
        })
        .catch(() => {
          this.changePasswordLoading = false
        })
    },
    // 文件上传
    handleAvatarSuccess(res) {
      if (res.status === 200) {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        })
        this.set({ ...this.info, avatar: res.body.url })
        this.$api.SYS_USER_CHANGE_AVATAR({
          avatarUrl: res.body.url,
          avatarCode: res.body.fileId
        })
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'error'
        })
      }
    },
    onChange(val) {
      if (!val) {
        this.$refs.resetPasswordForm.resetFields()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-icon {
  width: 15px;
}
</style>
